
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"20 9 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31.529 20.086l-3.647 7.683a.15.15 0 00.032.174l9.85 9.466a.15.15 0 00.207 0l9.85-9.466a.149.149 0 00.031-.173l-3.647-7.684a.148.148 0 00-.134-.086H31.665a.148.148 0 00-.136.086z","fill":"#50AF95"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M39.132 28.558c-.07.006-.436.027-1.251.027-.648 0-1.108-.02-1.27-.027-2.505-.11-4.374-.548-4.374-1.071 0-.524 1.87-.96 4.374-1.073v1.709c.164.011.633.04 1.281.04.778 0 1.167-.033 1.237-.04v-1.708c2.5.112 4.366.55 4.366 1.072s-1.865.96-4.365 1.07l.002.001zm0-2.32V24.71h3.488v-2.331h-9.497v2.331h3.488v1.529c-2.835.13-4.967.694-4.967 1.369s2.132 1.237 4.967 1.369v4.899h2.52v-4.901c2.829-.13 4.957-.694 4.957-1.368 0-.674-2.127-1.237-4.957-1.368z","fill":"#fff"}})])
          )
        }
      }
    